import React, { useMemo } from 'react';

import { IntroSkipButtonGroupContainer } from '@/scenarios/legacy-player/components/feature-player/ui/skin/intro-skip-button-group/container';

import { useCurrentEpisode } from '../../hooks/use-current-episode';

export const EpisodeIntroSkipButtonGroupContainerWithFilter: typeof IntroSkipButtonGroupContainer =
    ({ contentId, ...rest }) => {
        const currentEpisode = useCurrentEpisode(contentId);

        const tvSeriesContentId = useMemo(
            () => currentEpisode?.tvSeries?.contentId ?? '',
            [currentEpisode?.tvSeries?.contentId]
        );

        return <IntroSkipButtonGroupContainer contentId={tvSeriesContentId} {...rest} />;
    };
